var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.3223,
    r: 7.77817,
    transform: "rotate(-45 11 11.3223)",
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9127 14.2338C13.5553 14.5912 12.9759 14.5912 12.6186 14.2338L8.08915 9.70439C7.73179 9.34703 7.73179 8.76763 8.08915 8.41027C8.44651 8.05291 9.02591 8.05291 9.38327 8.41027L13.9127 12.9397C14.27 13.297 14.27 13.8764 13.9127 14.2338Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09237 14.2349C7.73501 13.8776 7.73501 13.2982 8.09237 12.9408L12.6218 8.41142C12.9791 8.05406 13.5585 8.05406 13.9159 8.41142C14.2733 8.76878 14.2733 9.34818 13.9159 9.70554L9.38649 14.2349C9.02913 14.5923 8.44973 14.5923 8.09237 14.2349Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1687927659a4a9f300aafb442ca25e5f.svg";
export { ForwardRef as ReactComponent };